import React from 'react';
import { CircleCheck as CheckCircle } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const FUETechniqueSection = () => {
  const { t } = useLanguage();

  const benefits = [
    t('fue.benefit1'),
    t('fue.benefit2'),
    t('fue.benefit3'),
    t('fue.benefit4')
  ];

  return (
    <section className="py-20 md:py-28 bg-white" data-testid="fue-technique-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div className="relative order-2 lg:order-1">
            <div className="rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://customer-assets.emergentagent.com/job_hairgraft-experts/artifacts/kikngkv7_Gemini_Generated_Image_865p13865p13865p.png"
                alt={t('fue.title')}
                className="w-full h-auto object-cover"
              />
            </div>
            <div className="absolute -bottom-6 -left-6 w-32 h-32 bg-[#009d9f]/20 rounded-full blur-2xl" />
            <div className="absolute -top-6 -right-6 w-24 h-24 bg-[#009d9f]/10 rounded-full blur-xl" />
          </div>

          <div className="space-y-6 order-1 lg:order-2">
            <div>
              <p className="text-sm font-semibold tracking-wider uppercase text-[#009d9f] mb-4">
                {t('fue.tagline')}
              </p>
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-slate-900 leading-tight" style={{ fontFamily: 'Manrope, sans-serif' }}>
                {t('fue.title')}{' '}
                <span className="text-[#009d9f]">{t('fue.titleHighlight')}</span>
              </h2>
            </div>
            <p className="text-lg md:text-xl text-slate-600 leading-relaxed">{t('fue.description')}</p>
            <div className="space-y-4 pt-4">
              {benefits.map((benefit, index) => (
                <div key={`benefit-${index}`} className="flex items-start gap-3">
                  <div className="w-6 h-6 rounded-full bg-[#009d9f] flex items-center justify-center flex-shrink-0 mt-0.5">
                    <CheckCircle className="w-4 h-4 text-white" />
                  </div>
                  <span className="text-slate-700">{benefit}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FUETechniqueSection;
